import { render, staticRenderFns } from "./DestruccionData.vue?vue&type=template&id=306ce18e&"
import script from "./DestruccionData.vue?vue&type=script&lang=js&"
export * from "./DestruccionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports